import {Button, ButtonGroup, DialogBody, DialogFooter, HStack, Separator} from "@chakra-ui/react";
import {Form, UI} from "components";
import {toaster} from "config";
import {API} from "config";
import useBankAccounts from "hooks/useBankAccounts";
import useBanks from "hooks/useBanks";
import useDistributor from "hooks/useDistributor";
import {useEffect, useRef, useState} from "react";

export default function Bank({...props}) {

    const submitRef = useRef()

    const distributor = useDistributor()
    const banks = useBanks()
    const bank_accounts = useBankAccounts()

    const [loading, setLoading] = useState(false)
    const [errors, setErrors] = useState(null)
    const [form, setForm] = useState({name: distributor.data?.name, method: 'pix'})

    const handleChange = ({target}) => {
        const {name, value} = target

        switch (name) {
            default:
                setForm({...form, [name]: value});
                break;
        }
    }

    const handleSubmit = async () => {
        debugger
        setLoading(true)

        try {
            await API.post('/bank_accounts', form)
            toaster.create({title: 'Conta bancária registrada', type: 'success'})
            setForm({})
            props.onClose()
            bank_accounts.refetch()
        } catch (err) {
            setErrors(err?.response?.data?.errors)
            toaster.create({
                title: 'Não foi possível registrar a conta.',
                description: err?.response?.data?.message,
                type: 'warning'
            })
        }

        setLoading(false)
    }

    useEffect(() => {
        setForm({
                method: 'pix',
                pix_type: 5,
                type: 1,
                'name': distributor.data?.company_name
            }
        )
    }, [props.open])

    return (
        <UI.Dialog loading={loading} size="sm" title="Cadastrar conta/chave pix" {...props}>
            <DialogBody>
                <Form.Container submitRef={submitRef} onSubmit={handleSubmit}>

                    <Form.BankSelect
                        key="bank_code"
                        required
                        label="Banco:"
                        name="bank_code"
                        items={banks.data || []}
                        value={form?.bank_id}
                        onValueChange={(id, code) => setForm({...form, bank_id: id, bank_code: code})}
                        disabled={loading || banks.loading}
                        error={errors?.bank_id}
                    />

                    <Form.Segment
                        required
                        label="Tipo de conta:"
                        items={
                            [
                                {label: <HStack><UI.Icon name="pix"/> Chave Pix</HStack>, value: 'pix'},
                                {label: <HStack><UI.Icon name="bank"/> Conta Bancária</HStack>, value: 'account'}
                            ]
                        }
                        defaultValue={form?.method}
                        onValueChange={e => setForm({...form, method: e.value})}
                        disabled={loading}
                    />

                    <Separator/>

                    <UI.Show visible={form?.method === 'pix'}>

                        <Form.Segment
                            label="Tipo de chave:"
                            items={
                                [
                                    {label: 'Telefone', value: 1},
                                    {label: 'Email', value: 2},
                                    {label: 'CPF', value: 3},
                                    {label: 'CNPJ', value: 4},
                                    {label: 'Chave Aleatória', value: 5}
                                ]
                            }
                            defaultValue={form?.pix_type}
                            onValueChange={e => setForm({...form, pix_type: e.value})}
                            disabled={loading}
                        />

                        <Form.Text
                            required
                            label="Chave Pix:"
                            name="pix_key"
                            value={form?.pix_key}
                            error={errors?.pix_key}
                            onChange={handleChange}
                            size="lg"
                            fontWeight="bold"
                            helper="Insira sua chave pix.: Telefone, E-mail, CPF, CNPJ ou Chave Aleatória"
                            disabled={loading}
                        />

                    </UI.Show>

                    <UI.Show visible={form?.method === 'account'}>

                        <Form.Text
                            required={form?.method === 'account'}
                            type="number"
                            label="Agência:"
                            name="agency"
                            value={form?.agency}
                            error={errors?.agency}
                            disabled={loading}
                            onChange={handleChange}
                            helper="O número da sua agência bancária com o dígito."
                            size="lg"
                        />

                        <Form.Text
                            required={form?.method === 'account'}
                            type="number"
                            label="Conta corrente:"
                            name="account"
                            value={form?.account}
                            error={errors?.account}
                            disabled={loading}
                            onChange={handleChange}
                            helper="O número da sua conta corrente com dígito."
                            size="lg"
                        />

                        <Form.Text
                            type="number"
                            label="Operação:"
                            name="operation"
                            value={form?.operation}
                            error={errors?.operation}
                            disabled={loading}
                            onChange={handleChange}
                            helper="O número da operação (se houver)."
                        />

                    </UI.Show>

                    <Form.Text
                        required
                        label="Titular:"
                        name="name"
                        defaultValue={distributor?.data?.company_name}
                        value={form?.name}
                        error={errors?.name}
                        disabled={loading}
                        onChange={handleChange}
                    />

                </Form.Container>
            </DialogBody>
            <DialogFooter>
                <ButtonGroup size="xs">
                    <Button colorPalette="orange"
                            onClick={() => submitRef.current.click()}
                            loading={loading}
                    >
                        <UI.Icon name="bank"/> Registrar conta bancária
                    </Button>
                    <Button variant="plain" onClick={props.onClose} disabled={loading}>
                        <UI.Icon name="close"/> Cancelar
                    </Button>
                </ButtonGroup>
            </DialogFooter>
        </UI.Dialog>
    )
}